<template>
  <div class="taskRecordSearch">
    <el-dialog
      title="精确查找工作记录"
      center
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-form size="mini" :model="para" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="记录类型">
              <el-select
                v-model="para.RecordType"
                size="mini"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重要级别">
              <el-rate :max="3" v-model="para.Degree"></el-rate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="接收人">
              <div style="display:flex">
                <ayb-select-user
                  @getValue="getSelectedExcuteUserId"
                  style="width:100%"
                  :idArray="arrExcuteUserId"
                ></ayb-select-user>
                <el-checkbox
                  border
                  size="small"
                  style="margin-left:2px;width: 80px;"
                  v-model="para.ExcuteMe"
                  >本人</el-checkbox
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="创建人 ">
              <div style="display:flex">
                <ayb-select-user
                  @getValue="getSelectedCreateUserId"
                  style="width:100%"
                  :idArray="arrCreateUserId"
                ></ayb-select-user>
                <el-checkbox
                  border
                  size="small"
                  style="margin-left:2px;width: 80px;"
                  v-model="para.CreateMe"
                  >本人</el-checkbox
                >
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建科室">
              <div style="display:flex">
                <ayb-selectInstitution
                  style="width:100%"
                  setWidth="100%"
                  :isRadio="false"
                  @getValue="getSelectedCreateDeptId"
                  :idArray="arrCreateDeptId"
                ></ayb-selectInstitution>
                <el-checkbox
                  border
                  size="small"
                  style="margin-left:2px;width: 80px;"
                  v-model="para.CreateDeptMe"
                  >本科室</el-checkbox
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="记录名称">
              <el-input
                v-model="para.Name"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="任务名称">
          <el-row>
            <el-col :span="22">
              <el-select
                v-model="taskIds"
                class="taskSelect"
                multiple
                filterable
                clearable
                popper-class="taskRecord_popperSelect"
                remote
                placeholder="请选择任务名称"
              >
                <el-option
                  v-for="item in taskList"
                  :key="item.ID"
                  :label="item.TASKNAME"
                  :value="item.ID"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-button
                icon="el-icon-plus"
                style="border-radius:0 4px 4px 0;border-left:0"
                @click="showTaskDialog"
              ></el-button>
            </el-col>
          </el-row>

          <!-- <el-input v-model="taskName"
                        size="mini"
                        placeholder="请输入内容">
                <el-button-group slot="append">
                  <el-button icon="el-icon-plus"
                             @click="showTaskDialog"></el-button>
                  <el-button icon="el-icon-minus"
                             style="margin:-15px -20px -10px 0"
                             @click="clearTaskName"></el-button>
                </el-button-group>
          </el-input>-->
          <!-- <el-input v-model="para.MainName"
                      size="mini"
          placeholder="请输入内容"></el-input>-->
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="创建时间">
              <div>
                <el-date-picker
                  v-model="para.CreatetimeRange"
                  style="width:100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  class="datePicker"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
                <div class="timeRange-div">
                  <el-radio-group
                    v-model="para.CreatetimeRadio"
                    class="timeRange-top"
                  >
                    <el-radio
                      @click.native.prevent="createclickitem(1)"
                      :label="1"
                      >最近七天</el-radio
                    >
                    <el-radio
                      @click.native.prevent="createclickitem(2)"
                      :label="2"
                      >最近一月</el-radio
                    >
                    <el-radio
                      @click.native.prevent="createclickitem(3)"
                      :label="3"
                    >
                      <div class="timeRange-bottom">
                        最近
                        <el-input
                          class="inputtime"
                          v-model="para.CreatetimeInput"
                          size="mini"
                        ></el-input>
                        <el-select
                          class="searchTime"
                          size="mini"
                          v-model="para.CreateTimeDynamic"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in timeOptions"
                            style="margin-left:2px"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <RelationTaskSearch ref="relationTaskSearch"
        :outRelation="relations"></RelationTaskSearch>-->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="clear">清空</el-button>
        <el-button type="primary" @click="searchRecord">确 定</el-button>
        <el-button class="btn" type="warning" @click="createTemplate"
          >保存模板</el-button
        >
      </span>
    </el-dialog>
    <taskDialog ref="taskSDialog" @getValue="getTask"></taskDialog>
  </div>
</template>
//工作记录精确搜索
<script>
import RelationTaskSearch from "./RelationTaskSearch.vue";
import searchJs from "@/util/search";
import { getToken } from "@/util/auth";
import taskDialog from "@/components/basicTemplate/common/taskDialog.vue";
const cookieUser = getToken();
export default {
  components: {
    RelationTaskSearch,
    taskDialog: () => import("@/components/basicTemplate/common/taskDialog.vue")
  },
  data() {
    return {
      dialogVisible: false,
      relations: [],
      taskIds: [],
      arrCreateUserId: [],
      arrExcuteUserId: [],
      arrCreateDeptId: [],
      taskList: [],
      options: [
        { label: "全部记录", value: -1 },
        { label: "工作日志", value: 0 },
        { label: "问询", value: 1 },
        { label: "代办事项", value: 2 },
        { label: "催办", value: 3 },
        { label: "提醒", value: 4 },
        { label: "会议", value: 5 }
      ],
      timeOptions: [
        {
          label: "小时",
          value: 1
        },
        {
          label: "天",
          value: 2
        },
        {
          label: "周",
          value: 3
        },
        {
          label: "月",
          value: 4
        }
      ],
      degreeOptions: [
        {
          label: "☆",
          value: 1
        },
        {
          label: "☆☆",
          value: 2
        },
        {
          label: "☆☆☆",
          value: 3
        }
      ],
      para: {
        SelectIndex: -1,
        RecordType: -1,
        CreateMe: false,
        ExcuteMe: false,
        Degree: 0,
        CreateDeptMe: false,
        CreatetimeRange: [], //创建时间
        CreatetimeRadio: "", //创建时间选择
        CreatetimeInput: "", //创建时间填写
        CreateTimeDynamic: 1, //创建时间（小时,天，周，月）
        CurUserId: cookieUser.userId
      },
      userId: cookieUser.userId,
      timeOptions: [
        {
          label: "小时",
          value: 1
        },
        {
          label: "天",
          value: 2
        },
        {
          label: "周",
          value: 3
        },
        {
          label: "月",
          value: 4
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    open(editData, tag) {
      this.dialogVisible = true;

      if (tag == 1) {
        //表示只带入搜索条件，但是非编辑
        if (editData) {
          //界面字段赋值
          let param = JSON.parse(editData.CONTENT);
          console.log("param:", param);
          this.setPara(param);
        }
      }
      if (tag == 0) {
        if (editData) {
          //编辑
          console.log("编辑搜索模板Obj:", editData);
          this.editMode = 1;
          let { ...emodel } = editData;
          this.editModel = emodel;
          //界面字段赋值
          console.log(editData);

          let param = editData.CONTENT
            ? JSON.parse(editData.CONTENT)
            : editData;
          console.log("param:", param);

          this.setPara(param);
        }
      }
    },
    setPara(oldPara) {
      this.para = Object.assign({}, oldPara);
      if (oldPara.CreateUserIds)
        this.arrCreateUserId = oldPara.CreateUserIds.split(",");
      if (oldPara.ExcuteUserIds)
        this.arrExcuteUserId = oldPara.ExcuteUserIds.split(",");

      if (oldPara.CreateDeptIds)
        this.arrCreateDeptId = oldPara.CreateDeptIds.split(",");
      if (oldPara.MainList) {
        this.taskList = oldPara.MainList;
        this.taskIds = oldPara.MainIds.split(",");
      }
    },
    createTemplate() {
      // searchJs.queryTaskTitle(this.getPara());
      this.getPara();
      let templateVal = {};
      templateVal.Alone = Object.assign({}, this.para);
      console.log("模板para", this.para);
      templateVal.queryTitle = this.queryTaskTitle();
      this.$emit("createTemplate", JSON.stringify(templateVal));
      console.log("模板内容", templateVal);
    },
    queryTaskTitle() {
      let queryTitle = [];
      let recordType = this.options.find(o => this.para.RecordType === o.value);
      console.log("类型", recordType.label);
      queryTitle.push({
        title: "类型",
        key: "RecordType",
        value: recordType.label
      });

      if (this.para.Degree != 0) {
        let degreeType = this.degreeOptions.find(
          o => this.para.Degree === o.value
        );
        console.log("degreeType", degreeType.label);
        queryTitle.push({
          title: "重要级别",
          key: "Degree",
          value: degreeType.label
        });
      }

      let ExcuteUserNames = this.para.ExcuteUserNames;
      if (this.para.ExcuteMe) {
        if (ExcuteUserNames) {
          ExcuteUserNames = ExcuteUserNames + ",本人";
        } else {
          ExcuteUserNames = "本人";
        }
      }
      if (ExcuteUserNames) {
        queryTitle.push({
          title: "执行人",
          key: "ExcuteUserIds",
          value: ExcuteUserNames
        });
      }

      let userNames = this.para.CreateUserNames;
      if (this.para.CreateMe) {
        if (userNames) {
          userNames = userNames + ",本人";
        } else {
          userNames = "本人";
        }
      }
      if (userNames) {
        queryTitle.push({
          title: "创建人",
          key: "CreateUserIds",
          value: userNames
        });
      }
      let deptNames = this.para.CreateDeptNames;
      if (this.para.CreateDeptMe) {
        if (deptNames) {
          deptNames = deptNames + ",本科室";
        } else {
          deptNames = "本科室";
        }
      }
      if (deptNames) {
        queryTitle.push({
          title: "创建科室",
          key: "CreateDeptIds",
          value: deptNames
        });
      }
      if (this.para.Name)
        queryTitle.push({
          title: "记录名称",
          key: "Name",
          value: this.para.Name
        });
      if (this.para.MainIds)
        queryTitle.push({
          title: "任务名称",
          key: "MainIds",
          value: this.para.MainNames
        });
      let createtimeTitle = searchJs.timeTitle(
        this.para.CreatetimeRange,
        this.para.CreatetimeRadio,
        this.para.CreatetimeInput,
        this.para.CreateTimeDynamic
      );
      if (createtimeTitle) {
        queryTitle.push({
          title: "创建时间",
          key: "CreateTime",
          value: createtimeTitle
        });
      }
      return queryTitle;
    },
    showTaskDialog() {
      this.$refs.taskSDialog.dialogVisible = true;
    },
    getTask(val) {
      this.taskIds = [];
      this.taskList = val;
      this.taskIds = val.map(v => v.ID);
      this.para.MainNames = val.map(v => v.TASKNAME);
      this.para.MainList = this.taskList.map(o => {
        return {
          ID: o.ID,
          TASKNAME: o.TASKNAME
        };
      });
    },
    getSelectedExcuteUserId(val) {
      if (val.length > 0) {
        console.log("人员", val);
        this.para.ExcuteUserIds = val.map(o => o.UserId).join(",");
        this.para.ExcuteUserNames = val.map(o => o.Name).join(",");
      } else {
        this.para.ExcuteUserIds = "";
        this.para.ExcuteUserNames = "";
      }
    },
    getSelectedCreateUserId(val) {
      if (val.length > 0) {
        console.log("人员", val);
        this.para.CreateUserIds = val.map(o => o.UserId).join(",");
        this.para.CreateUserNames = val.map(o => o.Name).join(",");
      } else {
        this.para.CreateUserIds = "";
        this.para.CreateUserNames = "";
      }
    },
    getSelectedCreateDeptId(val) {
      if (val.length > 0) {
        console.log("科室", val);
        this.para.arrCreateDeptId = val
          .filter(s => s.Type == 2)
          .map(s => s.SocialId)
          .join(",");
        this.para.CreateDeptNames = val
          .filter(s => s.Type == 2)
          .map(s => s.Name)
          .join(",");
      } else {
        this.para.arrCreateDeptId = "";
        this.para.CreateDeptNames = "";
      }
    },
    createclickitem(e) {
      e === this.para.CreatetimeRadio
        ? (this.para.CreatetimeRadio = "")
        : (this.para.CreatetimeRadio = e);
    },
    clear() {
      this.para = {
        SelectIndex: -1,
        RecordType: -1,
        CreateMe: false,
        ExcuteMe: false,
        Degree: 0,
        CreateDeptMe: false,
        CreatetimeRange: [], //创建时间
        CreatetimeRadio: "", //创建时间选择
        CreatetimeInput: "", //创建时间填写
        CreateTimeDynamic: 1, //创建时间（小时,天，周，月）
        CurUserId: cookieUser.userId
      };
      this.taskIds = [];
      this.arrCreateUserId = [];
      this.arrExcuteUserId = [];
      this.arrCreateDeptId = [];
    },
    getPara() {
      let timeRange = searchJs.timeDisposal(
        this.para.CreatetimeRange,
        this.para.CreatetimeRadio,
        this.para.CreatetimeInput,
        this.para.CreateTimeDynamic
      );
      if (timeRange) {
        if (timeRange.length === 2) {
          this.para.CreateTime1 = timeRange[0];
          this.para.CreateTime2 = timeRange[1];
        }
      }
      this.para.MainIds = this.taskIds.join(",");
      this.para.Alone = this.queryTaskTitle();
    },
    searchRecord() {
      this.getPara();
      this.dialogVisible = false;
      this.$emit("searchRecord", this.para);
    }
  }
};
</script>

<style scoped>
.taskRecord_popperSelect {
  display: none !important;
}
.taskSelect .el-input__inner {
  border-radius: 4px 0 0 4px;
}
</style>
<style lang="scss" scoped>
span {
  margin-right: 5px;
  text-align: -webkit-right;
  min-width: 70px;
}
.taskSelect {
  width: 100%;
}
.col-div {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: flex-end;
}
.timeRange-div {
  margin-top: 5px;
  display: flex;
  align-items: center;
}
.timeRange-top {
  width: 70%;
  display: flex;
}
.timeRange-bottom {
  display: inline-block !important;
  margin-left: 5px;
  width: 30%;
  display: flex;
}
.searchTime {
  width: 80px;
}
</style>
